import { render } from "./SideMenuBar.vue?vue&type=template&id=40e2c5b5"
import script from "./SideMenuBar.vue?vue&type=script&lang=js"
export * from "./SideMenuBar.vue?vue&type=script&lang=js"

import "./SideMenuBar.vue?vue&type=style&index=0&id=40e2c5b5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__